var utils = require('../../utils')
import AppHeader from '../AppHeader'

export default {
  name: 'user-edit',
  created () {
    this.search()
    this.getShops()
  },
  data () {
    return {
      canValidate: true,
      userImage: null,
      uploadFlg: false,
      age: null,
      remarkCount: 0,
      userMemoCount: 0,
      user_domain_content_work: null,
      upFlg: false,
      roles: [
        {label: '---', value: null},
        {label: '店長', value: 'shop_master'},
        {label: 'エリア長', value: 'area_master'},
        {label: '遊技台発注閲覧者', value: 'order_viewer'}, 
        {label: 'ユニット発注担当者', value: 'unit_master'},
        {label: '遊技台発注管理者', value: 'admin'}
      ],
      shops: [],
      user: {
        login_id: null,
        code: null,
        password: null,
        password_confirmation: null,
        user_name: null,
        user_firstname: null,
        user_name_furigana: null,
        user_firstname_furigana: null,
        user_sex: null,
        user_post_no: null,
        user_address: null,
        email: null,
        user_domain_content: null,
        user_mobile: null,
        user_tel: null,
        user_birthday: null,
        user_joinday: null,
        join_id: null,
        user_business_type_content: '',
        user_business_type_remarks: null,
        user_memo: null,
        image: null,
        machine_order_type: null,
        shop_ids: [],
      }
    }
  },
  computed: {
    userDetail: function() {
      return this.$store.getters.userDetailEdit
    },
    shops: function() {
      return this.$store.getters.userDetailshops
    },
    user_types: function() {
      return this.$store.getters.userDetailUserTypes
    },
    domains: function() {
      return this.$store.getters.userDetailDomains
    },
    business_types: function() {
      return this.$store.getters.userDetailBusinessTypes
    },
    joins: function() {
      return this.$store.getters.userDetailJoins
    },
    business_content () {
      return this.user.user_business_type_content ? this.user.user_business_type_content.replace(/\r?\n/g, '<br>') : ''
    },
    shop_ids: function() {
      return this.$store.getters.shopIds
    },
    required: function() {
      return {
        user_post_no: utils.isBlank(this.user.user_post_no),
        user_address: utils.isBlank(this.user.user_address),
        user_post_no_format: !utils.isPostNo(this.user.user_post_no)
      }
    },
    validation: function() {
      var hiragana = /^[\u3040-\u309fー]+$/
      var tel = /^0\d{1,4}-\d{1,4}-\d{3,4}$/
      var number = /^[0-9]+$/
      var pass = /^\w{4,10}$/
      var email = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]*$/

      var v = {
        login_id: !!this.user.login_id,
        code: !!this.user.code,
        password_rule: (pass.test(this.user.password) || !this.user.password),
        password_confirmation: this.user.password == this.user.password_confirmation,
        user_name: !!this.user.user_name,
        user_firstname: !!this.user.user_firstname,
        user_name_furigana: hiragana.test(this.user.user_name_furigana),
        user_firstname_furigana: hiragana.test(this.user.user_firstname_furigana),
        user_birthday: !!this.user.user_birthday,
        user_joinday: !!this.user.user_joinday,
        join_id: !!this.user.join_id,
        user_sex: !!this.user.user_sex,
        user_post_no: !!this.user.user_post_no,
        user_address: !!this.user.user_address,
        user_mobile: tel.test(this.user.user_mobile),
        user_tel: tel.test(this.user.user_tel) || !this.user.user_tel,
        user_email: this.user.email && email.test(this.user.email),
        domain_content: !!this.user.user_domain_content,
        email_domain: !!this.user.email && !!this.user.user_domain_content,

        not_input: !!this.user.login_id &&
                   (pass.test(this.user.password) || !this.user.password) &&
                   this.user.password == this.user.password_confirmation &&
                   !!this.user.user_name &&
                   !!this.user.user_firstname &&
                   hiragana.test(this.user.user_name_furigana) &&
                   hiragana.test(this.user.user_firstname_furigana) &&
                   !!this.user.user_birthday &&
                   !!this.user.user_joinday &&
                   !!this.user.join_id &&
                   !!this.user.user_sex &&
                   !!this.user.user_post_no &&
                   number.test(this.user.user_post_no) &&
                   !!this.user.user_address &&
                   tel.test(this.user.user_mobile) &&
                   (tel.test(this.user.user_tel) || !this.user.user_tel) &&
                   (this.user.email && email.test(this.user.email)) &&
                   !!this.user.user_domain_content &&
                   !this.uploadError
      }
      if (!this.canValidate) {
        Object.keys(v).forEach(key => { v[key] = true; });
      }
      return v
    },
    isValid () {
      var validation = this.validation
      return Object.keys(validation).every(function (key) {
        return validation[key]
      })
    },
    notify () {
      return this.$store.getters.userDetailEditUserNotify
    },
    loading () {
      return this.$store.getters.apiLoading
    },
    authToken() {
      return window.localStorage.getItem('access_token')
    },
    timeStamp() {
      var d = new Date()
      var year  = d.getFullYear()
      var month = d.getMonth() + 1
      var day   = d.getDate()
      var hour  = (d.getHours() < 10) ? '0' + d.getHours()   : d.getHours()
      var min   = (d.getMinutes() < 10) ? '0' + d.getMinutes() : d.getMinutes()
      var sec   = (d.getSeconds() < 10) ? '0' + d.getSeconds() : d.getSeconds()
      return year +''+ month +''+ day +''+ hour +''+ min +''+ sec
    },
    uploadSuccess() {
      return this.$store.getters.imageUploadSuccess
    },
    uploadError() {
      return this.$store.getters.imageUploadError
    }
  },
  components: {
    AppHeader
  },
  methods: {
    async getShops () {
      let data = {}
      let res = await this.$store.dispatch('GET_SHOP_TARGET_STOCK', data)
                                  .catch(err => {
                                    console.log(err)
                                    return
                                  })

      this.shops = res.data
      this.getShopsEndFlag = true
    },
    goUserLists: function () {
      utils.backClear()
      this.$router.push({ path: '/users', query: { type: this.$router.currentRoute.query.type}})
    },
    goShopLists: function () {
      utils.backClear()
      this.$router.push({ path: '/shops', query: { type: this.$router.currentRoute.query.type}})
    },
    onDragOver: function (event) {
      console.log('onDragOver')
      event.preventDefault()
    },
    onDrop: function (event) {
      console.log('onDrop')
      event.preventDefault()
      var files = event.target.files || event.dataTransfer.files
      this.upload(files[0])
    },
    onFileChange: function (event) {
      console.log('onFileChange')
      var files = event.target.files || event.dataTransfer.files
      this.upload(files[0])
    },
    upload: function (file) {
      this.upFlg = true
      var reader = new FileReader()
      var self = this
      reader.onload = (e) => {
        self.user.avartar = e.target.result
        var formData = new FormData()
        formData.append('avartar', file)
        self.$store.dispatch('USER_AVARTAR_UPLOAD', { data: formData, callback: self.onUpload })
      }
      reader.readAsDataURL(file)
    },
    onUpload: function (data) {
      this.userImage = data.image_path + '?token=' + this.authToken
      this.uploadFlg = true
    },
    search: function() {
      var data = {}
      var self = this
      var callback = function () {
        self.user.login_id = self.userDetail.attributes['login-id']
        self.user.code = self.userDetail.attributes['code']
        self.user.user_name = self.userDetail.attributes['user-name']
        self.user.user_firstname = self.userDetail.attributes['user-firstname']
        self.user.user_name_furigana = self.userDetail.attributes['user-name-furigana']
        self.user.user_firstname_furigana = self.userDetail.attributes['user-firstname-furigana']
        if(self.userDetail.attributes['user-sex'] == 'man') {
          self.user.user_sex = 1
        } else {
          self.user.user_sex = 2
        }
        self.user.user_post_no = self.userDetail.attributes['user-post-no']
        self.user.user_address = self.userDetail.attributes['user-address']
        self.user.email = self.userDetail.attributes['email']
        self.user.user_domain_content = self.userDetail.attributes['user-domain-content']
        self.user.user_mobile = self.userDetail.attributes['user-mobile']
        self.user.user_tel = self.userDetail.attributes['user-tel']
        self.user.user_birthday = self.userDetail.attributes['user-birthday']
        self.user.user_joinday = self.userDetail.attributes['user-joinday']
        self.user.join_id = self.userDetail.attributes['join-id']
        self.user.user_business_type_content = self.userDetail.attributes['business-type-content']
        self.user.user_business_type_remarks = self.userDetail.attributes['user-business-type-remarks']
        self.user.user_memo = self.userDetail.attributes['user-memo']
        self.user.machine_order_type = self.userDetail.attributes['machine-order-type']
        console.log(self.$store.getters.shopIds)
        self.user.shop_ids = self.shop_ids
        if(self.userDetail.attributes['user-avartar'] != null){
          self.userImage = self.userDetail.attributes['avartar-path'] + '?token=' + self.authToken + "&timestamp=" + self.timeStamp
        }
        self.calAge()
        self.remarkCounter()
        self.userMemoCounter()
      }

      this.$store.dispatch('USER_EDIT',  { id: this.$route.params.id, data: data, callback: callback })
    },
    onClickCancel: function () {
      this.$router.push('/users')
    },
    remarkCounter: function() {
      this.half()
      this.remarkCount = this.user.user_business_type_remarks.length
    },
    userMemoCounter: function() {
      this.half()
      this.userMemoCount = this.user.user_memo.length
    },
    onClickSave: function () {
      var hyphen = /^(\d{4})-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])$/
      if (!hyphen.test(this.user.user_joinday)) {
        this.user.user_joinday = this.user.user_joinday.getFullYear() + '-' + ("0" + (this.user.user_joinday.getMonth() + 1)).slice(-2) + '-' + ("0" + this.user.user_joinday.getDate()).slice(-2)
      }
      var data = {}
      var self = this
      self.canValidate = true
      if (this.isValid) {
        data = self.user
        this.$store.dispatch('USER_UPDATE', { data: data, callback: this.onSaved, user_id: self.$route.params.id })
      } else {
        console.log("need edit");
      }
    },
    onSaved: function (result) {
      this.$router.push('/users/' + this.$route.params.id)
    },
    calAge: function () {
      if (this.user.user_birthday) {
        var hyphen = /^(\d{4})-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])$/
        if (!hyphen.test(this.user.user_birthday)) {
          this.user.user_birthday = this.user.user_birthday.getFullYear() + '-' + ("0" + (this.user.user_birthday.getMonth() + 1)).slice(-2) + '-' + ("0" + this.user.user_birthday.getDate()).slice(-2)
        }
        var birthday = this.user.user_birthday.replace(/-/g,"")
        var today = new Date()
        var targetdate = today.getFullYear() * 10000 + (today.getMonth() + 1) * 100 + today.getDate()

        this.age = (Math.floor((targetdate - birthday) / 10000))
      } else {
        this.age = null
      }
    },
    onChangePostNo: function () {
      if (this.user.user_post_no) {
        this.user.user_post_no = this.user.user_post_no.replace(/-/g,"")
      }
      if (!!this.user.user_post_no && utils.regex.post_no.test(this.user.user_post_no)) {
        this.$store.dispatch('ADDRESS_GET', {
          postal_code: this.user.user_post_no, callback: (addr) => {
            if (addr) {
              this.user.user_address = addr.address1 + addr.address2
              this.onChangeAddress()
            }
          }
        })
      }
    },
    onChangeAddress: function () {
      var arr = []
      if (utils.isPresent(this.user.user_post_no)) arr.push(this.user.user_post_no)
      if (utils.isPresent(this.user.user_address)) arr.push(this.user.user_address)
      if (arr.length > 0) {
        var address = arr.join(' ')
        if (window.googleMapsQuerySearch) {
          window.googleMapsQuerySearch(address)
        }
      }
    },
    /** 画像押下 */
    onClickImageModalShow: function () {
      var button = document.getElementById('imageModalButton')
      var img    = document.getElementById('imageModalImg')
      var text   = document.getElementById('imageModalText')
      img.src = this.userImage
      text.textContent = ''
      button.click() // モーダル表示 イベント発火
    },
    selectedUserType: function() {
      var self = this
      self.user.user_business_type_content = ''
      for(var i=0; i < self.$store.getters.userDetailUserTypes.length; i++){
        var user_type = self.$store.getters.userDetailUserTypes[i]
        if (user_type.id == self.user.user_type_id) {
          self.user.user_authority = user_type.attributes['default-user-authority']
          for(var j=0; j < self.$store.getters.userDetailBusinessTypes.length; j++){
            var business_type = self.$store.getters.userDetailBusinessTypes[j]
            if (business_type.attributes['user-type-id'] == user_type.id) {
              self.user.user_business_type_content = self.user.user_business_type_content + business_type.attributes['business-type-content'] + ' '
            }
          }
          self.user.user_business_type_content = self.user.user_business_type_content.replace(/\s+$/g, "")
          break;
        }
      }
    },
    selectedDomain: function() {
      this.user.user_domain_content = this.user_domain_content_work
    },
    kanaSupport: function () {
      this.half()
      var self = this
      var data = {
        'user_name': self.user.user_name
      }
      var callback = function (){
        self.user.user_name_furigana = self.$store.getters.userNameKana
      }
      this.$store.dispatch('KANA_GET', {data: data, callback: callback})
    },
    kanaFirstSupport: function () {
      this.half()
      var self = this
      var data = {
        'user_name': self.user.user_firstname
      }
      var callback = function (){
        self.user.user_firstname_furigana = self.$store.getters.userNameKana
      }
      this.$store.dispatch('KANA_GET', {data: data, callback: callback})
    },
    half: function () {
      if (!utils.isBlank(this.user.user_name)) this.user.user_name = utils.emHalf(this.user.user_name)
      if (!utils.isBlank(this.user.user_firstname)) this.user.user_firstname = utils.emHalf(this.user.user_firstname)
      if (!utils.isBlank(this.user.user_address)) this.user.user_address = utils.emHalf(this.user.user_address)
      if (!utils.isBlank(this.user.email)) this.user.email = utils.emHalf(this.user.email)
      if (!utils.isBlank(this.user.user_domain_content)) this.user.user_domain_content = utils.emHalf(this.user.user_domain_content)
      if (!utils.isBlank(this.user.user_business_type_remarks)) this.user.user_business_type_remarks = utils.emHalf(this.user.user_business_type_remarks)
      if (!utils.isBlank(this.user.user_memo)) this.user.user_memo = utils.emHalf(this.user.user_memo)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/user-edit.js